import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import createTrack from 'services/actions/tracker_actions';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { maskCnpj } from 'utils/cnpj';
import { activeCompany } from './helpers';
import { buildQuestionnaireText, downloadQuestionnaireDocx } from './questionnaire';

interface QuestionnaireExportProps {
  compact: boolean;
}

const QuestionnaireExport: React.FC<QuestionnaireExportProps> = ({ compact }) => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [copied, setCopied] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const company = () => {
    const data = activeCompany(profile);
    return data ? { razaoSocial: data.razao_social || '', cnpj: maskCnpj(data.cnpj) } : null;
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(buildQuestionnaireText(company()));
      setError('');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      createTrack('Copiou questionário da API', {});
    } catch (err) {
      setError('Não foi possível copiar. Use a opção de baixar em Word.');
    }
  };

  const handleDownload = async () => {
    try {
      await downloadQuestionnaireDocx(company());
      setError('');
      createTrack('Baixou questionário da API', {});
    } catch (err) {
      setError('Não foi possível gerar o arquivo. Use a opção de copiar as perguntas.');
    }
  };

  const buttonClass = compact ? 'btn btn-sm btn-outline-secondary' : 'btn btn-outline-secondary';

  return (
    <div className={`border rounded p-3 ${compact ? 'mt-3' : 'mt-4'}`}>
      <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
        <div className="mb-2 mb-md-0 pr-md-3">
          <strong>Outra pessoa vai responder?</strong>
          <div className="text-muted">
            Copie ou baixe as perguntas e envie para quem tem as informações. Depois é só lançar as
            respostas aqui.
          </div>
        </div>
        <div className="d-flex flex-shrink-0">
          <button type="button" className={buttonClass} onClick={handleCopy}>
            <i className="material-icons align-middle mr-1">{copied ? 'check' : 'content_copy'}</i>
            {copied ? 'Copiado!' : 'Copiar perguntas'}
          </button>
          <button type="button" className={`${buttonClass} ml-2`} onClick={handleDownload}>
            <i className="material-icons align-middle mr-1">description</i>
            Baixar em Word
          </button>
        </div>
      </div>
      {error && <div className="text-danger small mt-2">{error}</div>}
    </div>
  );
};

export default QuestionnaireExport;
